import PersonaType from 'owa-service/lib/contract/PersonaType';

export enum FileType {
    None,
    ClassicAttachment,
    CloudAttachment,
    SharePointFile,
}

export enum FileActivity {
    None,
    Attached,
    Uploaded,
    Modified,
}

// base file item properties
export interface BaseFileInformation {
    id: string;
    name: string;
    size: number;
    extension: string;
    fileModifiedTime: string;
    fileType: FileType;
    lastModifiedBy: PersonaType;
    fileActivity: FileActivity;
    groupSmtpAddress: string;
    retrievedTime: Date; // The time we retrieve these file information from server.
}

export default BaseFileInformation;
